require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-press-release-mnuchin-development-committee-meeting.json") })
        }
      }, "path---en-us-update-press-release-mnuchin-development-committee-meeting");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-press-release-mnuchin-development-committee-meeting!./.cache/json/en-us-update-press-release-mnuchin-development-committee-meeting.json
// module id = 786
// module chunks = 231608221292675